import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchNotifications = createAsyncThunk('notifications/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/notifications');
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error);
  }
});

export const markAsRead = createAsyncThunk('notifications/markRead', async (id, { rejectWithValue }) => {
  try {
    const { data } = await api.put(`/notifications/${id}/read`);
    return data.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error);
  }
});

const notificationSlice = createSlice({
  name: 'notifications',
  initialState: {
    items: [], unreadCount: 0, loading: false,
  },
  reducers: {
    addNotification: (state, action) => {
      state.items.unshift(action.payload);
      state.unreadCount += 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.items = action.payload.data;
        state.unreadCount = action.payload.unreadCount;
      })
      .addCase(markAsRead.fulfilled, (state, action) => {
        const idx = state.items.findIndex(n => n._id === action.payload._id);
        if (idx >= 0) state.items[idx] = action.payload;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      });
  },
});

export const { addNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
